import styles from "./index.module.css";
import AtSecondSight from "../movieName/atSecondSight";
import AtSecondSightDetail from "../details/atSecondSight";
import LonelinessAndCompanionship from "../movieName/lonelinessAndCompanionship";
import LonelinessAndCompanionshipDetail from "../details/lonelinessAndCompanionship";
import ManAndFish from "../movieName/manAndFish";
import ManAndFishDetail from "../details/manAndFish";
import Misaligned from "../movieName/misaligned";
import MisalignedDetail from "../details/misaligned";
import TheMatch from "../movieName/theMatch";
import TheMatchDetail from "../details/theMatch";
import Poster from "../poster";
import MovieList from "../movieList";
import { useEffect, useRef, useState } from "react";
import { useSpring, useSprings, animated } from "@react-spring/web";
import { useDrag } from "@use-gesture/react";
import useMeasure from "react-use-measure";
import clamp from "lodash.clamp";
import Subject from "../subject";
import { gsap } from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import axios from "axios";
gsap.registerPlugin(ScrollToPlugin);
let href = window.location.href.split(".")[0];
let secHref = href.split("//")[1];
let movieData = [
  {
    name: "At Second Sight",
    author: "Dmitry Volny",
    videoSrc:
      "https://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/sm5sfilm2022/sm5sfilm2022-home-01-m.mp4",
    videoBTSPosterSrc:
      "https://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/sm5sfilm2022/sm5sfilm2022-BTS-01-cover.jpg",
    posterSrc:
      "https://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/sm5sfilm2022/sm5sfilm2022-home-01-cover.jpg",

    svg: AtSecondSight,
    detail: AtSecondSightDetail,
    proportion: 16 / 9,
  },
  {
    name: "Loneliness and Companionship",
    author: "Kristofh Pozo",
    videoSrc:
      "https://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/sm5sfilm2022/sm5sfilm2022-home-02-m.mp4",
    videoBTSPosterSrc:
      "https://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/sm5sfilm2022/sm5sfilm2022-BTS-02-cover.jpg",
    posterSrc:
      "https://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/sm5sfilm2022/sm5sfilm2022-home-02-cover.jpg",
    svg: LonelinessAndCompanionship,
    detail: LonelinessAndCompanionshipDetail,
    proportion: 16 / 9,
  },
  {
    name: "Man & Fish",
    author: "Reangsei Phos",
    videoSrc:
      "https://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/sm5sfilm2022/sm5sfilm2022-home-03-m.mp4",
    videoBTSPosterSrc:
      "https://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/sm5sfilm2022/sm5sfilm2022-BTS-03-cover.jpg",
    posterSrc:
      "https://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/sm5sfilm2022/sm5sfilm2022-home-03-cover.jpg",
    svg: ManAndFish,
    detail: ManAndFishDetail,
    proportion: 16 / 9,
  },
  {
    name: "Misaligned",
    author: "TRIO Stories",
    videoSrc:
      "https://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/sm5sfilm2022/sm5sfilm2022-home-04-m.mp4",
    videoBTSPosterSrc:
      "https://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/sm5sfilm2022/sm5sfilm2022-BTS-04-cover.jpg",
    posterSrc:
      "https://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/sm5sfilm2022/sm5sfilm2022-home-04-cover.jpg",
    svg: Misaligned,
    detail: MisalignedDetail,
    proportion: 16 / 6.8,
  },
  {
    name: "The Match",
    author: "Vincenzo De Caro",
    videoSrc:
      "https://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/sm5sfilm2022/sm5sfilm2022-home-05-m.mp4",
    videoBTSPosterSrc:
      "https://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/sm5sfilm2022/sm5sfilm2022-BTS-05-cover.jpg",
    posterSrc:
      "https://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/sm5sfilm2022/sm5sfilm2022-home-05-cover.jpg",
    svg: TheMatch,
    detail: TheMatchDetail,
    proportion: 16 / 8,
  },
];

const Header = ({
  handlePlayVisble,
  handlePlayHidden,
  handlePlayToggle,
  setLoadProgressState,
  handleStartPlay,
  handleClosePlay,
  isMobile,
}) => {
  const index = useRef(0);
  const playing = useRef(false);
  const posterChildRef0 = useRef();
  const posterChildRef1 = useRef();
  const posterChildRef2 = useRef();
  const posterChildRef3 = useRef();
  const posterChildRef4 = useRef();
  const refs = [
    posterChildRef0,
    posterChildRef1,
    posterChildRef2,
    posterChildRef3,
    posterChildRef4,
  ];
  const [fullScrenEleRef, { width, height }] = useMeasure();
  const [movieListStyle, setMovieListStyle] = useSpring(() => ({
    opacity: 1,
    pointerEvents: "all",
    config: { tension: 280, friction: 60 },
  }));
  const [posterStyles, setPosterStyles] = useSprings(
    movieData.length,
    (i) => ({
      x: (i - index.current) * width,
      scale: width === 0 ? 0 : 1,
      display: "block",
      config: { tension: 140, friction: 30 },
    }),
    [width]
  );

  const [dashoffset, setDashoffset] = useSprings(movieData.length, (i) => ({
    dashoffset: i === index.current ? 1 : 0,
    config: { tension: 600, friction: 240 },
  }));

  const [videoSpringStyles, setVideoSpringStyles] = useSprings(
    movieData.length,
    (i) => {
      return {
        opacity: 0,
        pointerEvents: "none",
        config: { tension: 400, friction: 120 },
      };
    }
  );
  const [coverSpringStyles, setCoverSpringStyles] = useSprings(
    movieData.length,
    () => {
      return {
        opacity: 1,
        pointerEvents: "all",
        config: { tension: 400, friction: 120 },
      };
    }
  );
  const [coverClipPathSpring, setCoverClipPathSpring] = useSprings(
    movieData.length,
    () => {
      return {
        clipPathTop: 0,
        clipPathBottom: 0,

        config: { tension: 400, friction: 120 },
      };
    }
  );

  const [movieNameStyles, setMovieNameStyles] = useSprings(
    movieData.length,
    () => {
      return {
        opacity: 1,
        pointerEvents: "all",
        config: { tension: 400, friction: 120 },
      };
    }
  );

  const [posterBoxStyles, setPosterBoxStyles] = useSprings(
    movieData.length,
    () => {
      return {
        position: "absolute",
        config: { tension: 400, friction: 120 },
      };
    }
  );

  const [headerCtnStyles, setHeaderCtnStyles] = useSpring(
    () => ({
      height: playing.current === true ? "auto" : height,
      config: { tension: 0, friction: 0 },
    }),
    [height]
  );

  const [inputFocus, setInputFocus] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [inputStatus, setInputStatus] = useState("failed");
  const onSubmit = (e) => {
    e.preventDefault();
    console.log(inputValue);
    let emailReg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
    if (inputValue === "") {
      setInputStatus("Please enter your email");
      return;
    } else if (!emailReg.test(inputValue)) {
      setInputStatus("Invalid email address");
      return;
    }

    setInputStatus("loading");

    axios({
      method: "post",
      url: `https://${secHref}.zhiyun-tech.com/en/active/collect`,
      data: {
        formId: 6,
        name1: inputValue,
      },
      headers: {
        "X-CSRF-TOKEN":
          window?.axios?.defaults?.headers?.common["X-CSRF-TOKEN"],
      },
    })
      .then(function (response) {
        let res = response.data;
        // console.log(res);
        if (res.code === 0) {
          setInputStatus("passed");
        } else if (res.code === 10003) {
          setInputStatus("The email you entered has already been used");
        } else {
          setInputStatus("Reserve failed, please try again later");
        }
      })
      .catch(function (error) {
        console.log(error);
        setInputStatus("Reserve failed, please try again later");
      });
  };

  useEffect(() => {
    window.onkeydown = (e) => {
      if (e.keyCode === 27) {
        refs[index.current].current.closeVideo();
        handlePlayToggle("play");
      }
    };
  }, []);

  const setPlayingState = (value) => {
    playing.current = value;
  };

  // useEffect(() => {
  //   setDashoffset.start((i) => {
  //     let dashoffset = 1;
  //     return {
  //       dashoffset,
  //       config: { tension: 400, friction: 120 }
  //     };
  //   });
  // },[])

  const handleIndexChange = (i, inHomePage = true) => {
    index.current = i;
    setPosterStyles.start((i) => {
      const x = (i - index.current) * width;
      const scale = i === index.current ? 1 : 0.8;
      // const c = active ? 1 - Math.abs(mx) / width : 1;
      return {
        x,
        scale,
        display: "block",
        config: inHomePage
          ? { tension: 140, friction: 30 }
          : { tension: 0, friction: 0 },
      };
    });

    setDashoffset.start((i) => {
      let dashoffset;
      if (index.current === i) {
        dashoffset = 1;
      } else {
        dashoffset = 0;
      }
      return {
        dashoffset,
        delay: 500,
        config: inHomePage
          ? { tension: 400, friction: 120 }
          : { tension: 0, friction: 0 },
      };
    });

    document.querySelectorAll(".movie-list-line").forEach((item, index) => {
      item.classList.remove("active");
      if (index === i) {
        item.classList.add("active");
        if (!inHomePage) {
          document.querySelectorAll(".movie-list-line")[
            i
          ].style.animationPlayState = "paused";
        }
      }
    });
  };

  const handleNextIndex = (inHomePage = true) => {
    let nextIndex =
      index.current < movieData.length - 1 ? index.current + 1 : 0;
    if (!inHomePage) {
      refs[index.current].current.closeVideo(inHomePage);
      refs[nextIndex].current.playVideo(inHomePage);
      setPosterBoxStyles.start((i) => {
        const position = i === nextIndex ? "relative" : "absolute";
        return {
          position,
        };
      });
      gsap.to(window, { duration: 1, scrollTo: 0 });
    }
    handleIndexChange(nextIndex, inHomePage);
  };

  const handleLastIndex = (inHomePage = true) => {
    let lastIndex =
      index.current > 0 ? index.current - 1 : movieData.length - 1;

    if (!inHomePage) {
      refs[index.current].current.closeVideo(inHomePage);
      refs[lastIndex].current.playVideo(inHomePage);
      setPosterBoxStyles.start((i) => {
        const position = i === lastIndex ? "relative" : "absolute";
        return {
          position,
        };
      });
      gsap.to(window, { duration: 1, scrollTo: 0 });
    }

    handleIndexChange(lastIndex, inHomePage);

  };
  const controlsHeight = isMobile ? 0 : 0;
  const playVideo = () => {
    setMovieListStyle.start(() => {
      return {
        opacity: 0,
        pointerEvents: "none",
      };
    });

    setMovieNameStyles.start(() => {
      return {
        opacity: 0,
        pointerEvents: "none",
        delay: 300,
      };
    });
    setCoverSpringStyles.start((i) => {
      return {
        opacity: 0,
        pointerEvents: "none",
        delay: 1400,
      };
    });
    setVideoSpringStyles.start(() => {
      return {
        opacity: 1,
        pointerEvents: "all",
        delay: 1400,
      };
    });
    setCoverClipPathSpring.start((i) => {
      return {
        clipPathTop:
          movieData[i].proportion >= width / (height - controlsHeight * 2)
            ? controlsHeight +
              (height - controlsHeight * 2) / 2 -
              width / movieData[i].proportion / 2
            : controlsHeight,
        clipPathBottom:
          movieData[i].proportion >= width / (height - controlsHeight * 2)
            ? controlsHeight +
              (height - controlsHeight * 2) / 2 -
              width / movieData[i].proportion / 2
            : controlsHeight,
        delay: 300,
      };
    });

    setPosterBoxStyles.start((i) => {
      const position = i === index.current ? "relative" : "absolute";
      return {
        position,
        delay: 1400,
      };
    });

    setHeaderCtnStyles.start(() => {
      return {
        height: "auto",
        delay: 1400,
      };
    });

    handlePlayToggle();
    setPlayingState(true);
    document.querySelectorAll(".movie-list-line")[
      index.current
    ].style.animationPlayState = "paused";
    // setPosterStyles.start(() => {
    //   return {
    //     dashoffset:0
    //   }
    // })
  };

  const closeVideo = () => {
    setMovieListStyle.start(() => {
      return {
        to: {
          opacity: 1,
          pointerEvents: "all",
        },
        delay: 800,
      };
    });
    setMovieNameStyles.start(() => {
      return {
        opacity: 1,
        pointerEvents: "all",
        delay: 800,
      };
    });
    setCoverSpringStyles.start(() => {
      return {
        opacity: 1,
        pointerEvents: "all",
      };
    });
    setVideoSpringStyles.start(() => {
      return {
        opacity: 0,
        pointerEvents: "none",
      };
    });
    setCoverClipPathSpring.start(() => {
      return {
        clipPathTop: 0,
        clipPathBottom: 0,
        delay: 400,
      };
    });
    setPosterBoxStyles.start(() => {
      return {
        position: "absolute",
      };
    });

    setHeaderCtnStyles.start(() => {
      return {
        height: height,
      };
    });
    setPlayingState(false);
    document.querySelectorAll(".movie-list-line").forEach((item) => {
      item.style.animationPlayState = "running";
    });

    // setPosterStyles.start(() => {
    //   return {
    //     dashoffset:1,
    //     delay:200
    //   }
    // })
  };

  const detailIsRender = (index) => {
    let nextIndex = index < movieData.length - 1 ? index + 1 : 0;
    let lastIndex = index > 0 ? index - 1 : movieData.length - 1
    refs[index].current.setIsRender(true);
    refs[nextIndex].current.setIsRender(true);
    refs[lastIndex].current.setIsRender(true);
  };

  console.log("组件:Header 重新渲染");
  return (
    <animated.div
      className={`${styles.ctn} header-ctn`}
      style={{
        ...headerCtnStyles,
      }}
    >
      {posterStyles.map(({ x, display, scale }, i) => {
        return (
          <animated.div
            className={`${styles.posterBox} poster-box`}
            key={i}
            style={{ display, x, scale, position: posterBoxStyles[i].position }}
          >
            <Poster
              movieData={movieData[i]}
              handlePlayVisble={handlePlayVisble}
              handlePlayHidden={handlePlayHidden}
              handlePlayToggle={handlePlayToggle}
              currentIndex={index.current}
              setLoadProgressState={setLoadProgressState}
              handleClosePlay={handleClosePlay}
              handleStartPlay={handleStartPlay}
              index={i}
              playVideoProps={playVideo}
              closeVideoProps={closeVideo}
              dashoffsetProps={dashoffset[i].dashoffset}
              innerWidth={width}
              innerHeight={height}
              isMobile={isMobile}
              videoSpringStyles={videoSpringStyles[i]}
              coverSpringStyles={coverSpringStyles[i]}
              coverClipPathSpring={coverClipPathSpring[i]}
              handleNextIndex={handleNextIndex}
              handleLastIndex={handleLastIndex}
              movieNameStyles={movieNameStyles[i]}
              ref={refs[i]}
              setPlayingState={setPlayingState}
              inputFocus={inputFocus}
              inputValue={inputValue}
              setInputFocus={setInputFocus}
              setInputValue={(value) => {
                setInputValue(value);
                setInputStatus("failed");
              }}
              inputStatus={inputStatus}
              onSubmit={onSubmit}
            />
          </animated.div>
        );
      })}

      <MovieList
        movieData={movieData}
        handleIndexChange={handleIndexChange}
        isMobile={isMobile}
        movieListStyle={movieListStyle}
        index={index.current}
        handleNextIndex={handleNextIndex}
      />

      <Subject movieListStyle={movieListStyle} />

      <animated.div
        style={{
          opacity: movieListStyle.opacity,
        }}
        onClick={handleNextIndex}
        className={styles.arrowRight}
        data-cursor-magnetic
        data-cursor-size="80px"
      >
        <svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M11 3L23 15L11 27" stroke="white" />
        </svg>
      </animated.div>

      <animated.div
        style={{
          opacity: movieListStyle.opacity,
        }}
        className={styles.arrowLeft}
        onClick={handleLastIndex}
        data-cursor-magnetic
        data-cursor-size="80px"
      >
        <svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M19 3L7 15L19 27" stroke="white" />
        </svg>
      </animated.div>

      <div className={styles.fullScrenEle} ref={fullScrenEleRef}></div>
    </animated.div>
  );
};

export default Header;
